// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2F-IT","overflowing":"ReadFullNote_overflowing__1g9Nb"};